var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("pulse-loader", {
              staticClass: "text-center",
              attrs: {
                loading: _vm.loading.invoices,
                color: _vm.$constants.LOADING_COLOR,
              },
            }),
            _vm._v(" "),
            !_vm.loading.invoices && _vm.invoicesLoaded
              ? _c("div", [
                  _c("table", { staticClass: "table table-sm table-hover" }, [
                    _c(
                      "tbody",
                      _vm._l(_vm.invoices, function (i, index) {
                        return _c(
                          "tr",
                          {
                            key: i.id,
                            class: { "bordered_2 extra_drugs_tr": index === 0 },
                          },
                          [
                            _c("td", [_vm._v(_vm._s(i.id))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(i.comment))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.printDate(i.created_at, "DD.MM.YYYY")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-default",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getDetails(false, i.id)
                                    },
                                  },
                                },
                                [_vm._v("показать накладную\n              ")]
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-1 text-right" },
                    [
                      Object.keys(_vm.selectedInvoices).filter(
                        (i) => _vm.selectedInvoices[i]
                      ).length > 1
                        ? _c("LoadingButton", {
                            attrs: {
                              title: "Показать препараты",
                              className: "btn btn-outline-info ",
                              onClick: () => _vm.getDetails(),
                              loading: _vm.loading.btnLoadInvoiceDetails,
                              color: _vm.$constants.PRIMARY_COLOR,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: {
          loading: _vm.loading.btnLoadInvoiceDetails,
          color: _vm.$constants.LOADING_COLOR,
        },
      }),
      _vm._v(" "),
      _vm.showInvoiceDetails || _vm.loading.invoiceDetails
        ? [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "flex" }, [
                  _c("div", { staticClass: "flex-grow-1" }, [
                    _c("label", [_vm._v("Поиск препарата")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchTitle,
                            expression: "searchTitle",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.searchTitle },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.searchTitle = $event.target.value
                            },
                            _vm.onInputSearch,
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            attrs: { type: "button" },
                            on: {
                              click: () => {
                                _vm.searchTitle = ""
                                this.onInputSearch()
                              },
                            },
                          },
                          [_vm._v("Очистить поиск\n                ")]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("div", { staticClass: "flex justify-content-between" }, [
                  _c("h5", [_vm._v("Препараты")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm.selectedManyInvoices &&
                      _vm.selectedManyInvoices[0] &&
                      _vm.changeInvoiceStatus === 0
                        ? _c("LoadingButton", {
                            attrs: {
                              title: "Начать приемку",
                              type: "button",
                              className: "btn btn-primary",
                              onClick: () => _vm.updateInvoiceStatus(1),
                              loading: _vm.loading.changeStatusBtn,
                              color: "white",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedManyInvoices &&
                      _vm.selectedManyInvoices[0] &&
                      _vm.changeInvoiceStatus === 1
                        ? _c("LoadingButton", {
                            attrs: {
                              title: "Остановить приемку ",
                              type: "button",
                              className: "btn btn-primary",
                              onClick: () => _vm.updateInvoiceStatus(0),
                              loading: _vm.loading.changeStatusBtn,
                              color: "white",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm.selectedManyInvoices &&
                      _vm.selectedManyInvoices[0] &&
                      _vm.changeInvoiceStatus === 3
                        ? _c("LoadingButton", {
                            attrs: {
                              title: "Накладная принята",
                              type: "button",
                              className: "btn btn-outline-success",
                              onClick: () =>
                                _vm.passInvoiceToModeration(
                                  _vm.selectedManyInvoices[0]
                                ),
                              loading:
                                _vm.loading.invoicesButtons[
                                  _vm.selectedManyInvoices[0]
                                ],
                              color: _vm.$constants.PRIMARY_COLOR,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("pulse-loader", {
                    staticClass: "text-center",
                    attrs: {
                      loading: _vm.loading.invoiceDetails,
                      color: _vm.$constants.LOADING_COLOR,
                    },
                  }),
                  _vm._v(" "),
                  _vm.showInvoiceDetails
                    ? _c("div", [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("table", { staticClass: "table table-sm mt-0" }, [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(_vm.filteredRecords, function (r, i) {
                                return _c(
                                  "tr",
                                  {
                                    key: r?.drug?.id,
                                    class: {
                                      bg_danger: +r.qty !== +r.income_qty,
                                    },
                                  },
                                  [
                                    _c("td", [_vm._v(_vm._s(i + 1))]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c("DrugTitleWithImage", {
                                          attrs: { drug: r.drug },
                                        }),
                                        _vm._v(" "),
                                        _c("DrugDimensionInfo", {
                                          attrs: {
                                            addDimension: () =>
                                              _vm.openDimension(r.drug.id),
                                            dimensions: _vm.hasDimensionRecords(
                                              r.all_details
                                            ),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-info btn-sm flex",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              _vm.uploadImages(
                                                Object.values(r.details)[0].id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon-im icon-im-plus",
                                          }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "icon-fa icon-ln icon-ln-photo align-self-center",
                                          }),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        (r.files ?? []).length
                                          ? [
                                              _c("PreviewPage", {
                                                attrs: {
                                                  files: r.files,
                                                  hidePreview: true,
                                                },
                                              }),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            r.invoices.length > 1
                                              ? r.invoices
                                              : null
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        !_vm.showDimensions[r.drug.id]
                                          ? [
                                              !_vm.hasDimensionRecords(
                                                r.all_details
                                              ).length
                                                ? _c(
                                                    "button",
                                                    {
                                                      class: {
                                                        btn: true,
                                                        "btn-danger": true,
                                                      },
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openDimension(
                                                            r.drug.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "добавить размеры\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _c("CountryDimension", {
                                              ref: "countryDimensions",
                                              refInFor: true,
                                              attrs: {
                                                drugId: r.drug.id,
                                                updateRecords: true,
                                                addEmpty: true,
                                                onSave: () =>
                                                  _vm.getDetails(
                                                    true,
                                                    _vm.getSelectedInvoice().id
                                                  ),
                                                countryId:
                                                  _vm.getSelectedInvoice()
                                                    .country_id,
                                                records: r.all_details,
                                              },
                                            }),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("strong", [_vm._v(_vm._s(r.qty))]),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "num_input" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: r.income_qty,
                                            expression: "r.income_qty",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "number",
                                          disabled:
                                            _vm.changeInvoiceStatus === 0,
                                        },
                                        domProps: { value: r.income_qty },
                                        on: {
                                          change: function ($event) {
                                            return _vm.updateQty(r)
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              r,
                                              "income_qty",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        class: {
                                          valid_date_warning:
                                            _vm.alertList.validDates[r.drug.id],
                                        },
                                      },
                                      [
                                        _vm.expDatesLoaded
                                          ? _c("ExpireDatesByMask", {
                                              ref: `expire_dates_${r.drug.id}`,
                                              refInFor: true,
                                              attrs: {
                                                allToSelectDate: true,
                                                disableEdit: true,
                                                invoiceId:
                                                  _vm.getSelectedInvoice().id,
                                                "drug-id": r.drug.id,
                                                savedDates:
                                                  _vm.savedExpireDates[
                                                    r.drug.id
                                                  ] ?? {},
                                                expireDates:
                                                  _vm.expireDates[r.drug.id] ??
                                                  [],
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm.loading.searchDrugs ||
                              _vm.extraDrugsRecords.length > 0
                                ? [
                                    _c(
                                      "tr",
                                      { staticClass: "extra_drugs_tr" },
                                      [
                                        _c(
                                          "td",
                                          { attrs: { colspan: "10" } },
                                          [
                                            _vm.loading.searchDrugs
                                              ? [
                                                  _c("pulse-loader", {
                                                    staticClass: "text-center",
                                                    attrs: {
                                                      loading: true,
                                                      color:
                                                        _vm.$constants
                                                          .LOADING_COLOR,
                                                    },
                                                  }),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                    Препараты, которые соответсвуют поиску и могут быть добавлены в накладную\n                  "
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.extraDrugsRecords,
                                      function (r, ii) {
                                        return _c("tr", { key: r.id }, [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                ii +
                                                  1 +
                                                  _vm.filteredRecords.length
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            [
                                              _c("DrugTitleWithImage", {
                                                attrs: { drug: r },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("td"),
                                          _vm._v(" "),
                                          _c("td"),
                                          _vm._v(" "),
                                          _c("td"),
                                          _vm._v(" "),
                                          _vm._m(3, true),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "num_input" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: r.qty,
                                                    expression: "r.qty",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "number",
                                                  disabled:
                                                    _vm.changeInvoiceStatus ===
                                                    0,
                                                },
                                                domProps: { value: r.qty },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.updateQty(r)
                                                  },
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      r,
                                                      "qty",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ])
                                      }
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-right mt-1" },
                          [
                            _vm.selectedManyInvoices &&
                            _vm.selectedManyInvoices[0] &&
                            _vm.changeInvoiceStatus === 3
                              ? _c("LoadingButton", {
                                  attrs: {
                                    title: "Накладная принята",
                                    type: "button",
                                    className: "btn btn-outline-success",
                                    onClick: () =>
                                      _vm.passInvoiceToModeration(
                                        _vm.selectedManyInvoices[0]
                                      ),
                                    loading:
                                      _vm.loading.invoicesButtons[
                                        _vm.selectedManyInvoices[0]
                                      ],
                                    color: _vm.$constants.PRIMARY_COLOR,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Накладные на получение")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info text-right" }, [
      _c("h4", [
        _vm._v("Указывайте или добавляйте сроки годности "),
        _c("strong", [_vm._v("только")]),
        _vm._v(" текущего поступления препаратов"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { attrs: { width: "400px" } }, [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Габариты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ожидаемое")]),
        _vm._v(" "),
        _c("th", [_vm._v("Фактическое")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "180px" } }, [_vm._v("Срок годности")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("0")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }